import dynamic from 'next/dynamic'
import React from 'react'

import { Box, Grid } from '@material-ui/core'

import AdsSlot from '~/components/shared/AdSlot'
import Desktop from '~/containers/Desktop'
import Mobile from '~/containers/Mobile'
import { ReCaptchaProvider } from '~/containers/ReCaptchaProvider'

import BlogSubscribe from '../Blog/BlogSubscribe'

const StickyContainer = dynamic(() =>
  import('~/components/shared/StickyContainer')
)

const sidebarSection = (
  <Grid style={{ marginTop: 50 }} container spacing={3} justify="flex-end">
    <Grid item xs={12} md={4} lg={12}>
      <Box>
        <ReCaptchaProvider>
          <BlogSubscribe />
        </ReCaptchaProvider>
      </Box>
    </Grid>
    <Grid item xs={12} md={4} lg={12}>
      <Box display="flex" justifyContent="center" flexWrap="wrap" mt={2}>
        <AdsSlot
          slotId="gam_halfpagemrec_posR1"
          sizes={[
            [300, 600],
            [300, 250]
          ]}
          sizeMapping={[
            {
              viewport: [1280, 0],
              sizes: [
                [300, 600],
                [300, 250]
              ]
            },
            { viewport: [0, 0], sizes: [] }
          ]}
          targetingArguments={{ pos: 'R1' }}
        />
      </Box>
    </Grid>
  </Grid>
)

const SearchSidebar = () => {
  return (
    <>
      <Desktop>
        <StickyContainer marginTop="30px">{sidebarSection}</StickyContainer>
      </Desktop>
      <Mobile>{sidebarSection}</Mobile>
    </>
  )
}

export default SearchSidebar
